import request from '@/utils/request'

let AlbumApi = {

  /*协议列表*/
  list(data) {
    return request._post('/shop/plus.album.Index/index', data);
},
/*添加协议*/
add(data) {
    return request._post('/shop/plus.album.Index/add', data);
},
/*修改协议*/
edit(data) {
    return request._post('/shop/plus.album.Index/edit', data);
},
/*删除协议*/
del(data) {
    return request._post('/shop/plus.album.Index/del', data);
},
/*协议详情*/
detail(data) {
  return request._post('/shop/plus.album.Index/detail', data);
},

}
export default AlbumApi;



// WEBPACK FOOTER //
// ./src/api/album.js